import React from "react"
import SEO from "../components/seo"
import "./awardees.css"
import logo from "../images/logo.png"

const CompanyAwardees = () => {
	const awardees = [
		"Ashlee Barrett",
		"Carly Griffin",
		"Jason Palpal-Iatoc",
		"Ethan Batchelder",
		"Brady Hager",
		"Preetika Perumalla",
		"Britain Bayer",
		"Stephanie Hayd",
		"Lindsey Repp",
		"Cynthia Benzel",
		"Suhaeng Huh",
		"Parker Salgat",
		"Kavya Bhavsar",
		"Courtney Kaufman",
		"Samantha Slonecker",
		"Ashley Biundo",
		"Hunter King",
		"Natalie Stark",
		"Andrew Borden",
		"Ryder Maljaars",
		"Isabella Tavormina",
		"Daira Chappell",
		"Bryanna Metcalf",
		"Jissel Vanegas",
		"Wyatt Draves",
		"Hayden Meyer",
		"Benjamin Wald",
		"Grace Farrell",
		"Emma Mulligan",
		"Ella Webb",
		"Hannah Fries",
		"Will Needlman",
		"Amelia Wedemeyer",
		"Kate Padron",
	];

	return (
		<div className="awardees">
			<img className="logo" src={logo} />
			<h2 className="awardee-header">We are pleased to announce the 2025 Brunswick Company Sons &amp; Daughters Scholarship Program Awardees</h2>
			<div className="awardee-grid">
				{awardees.map((awardee) => <span>{awardee}</span>)}
			</div>
		</div>
	);
};

export default CompanyAwardees
